import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CopyTextComponent } from './copy-text.component';
import { ToastModule } from 'primeng/toast';


@NgModule({
  declarations: [
    CopyTextComponent
  ],
  imports: [
    CommonModule,
    ToastModule
  ],
  exports: [
    CopyTextComponent
  ]
})
export class CopyTextModule { }
